package org.example.project.screens_cus_mobile

import androidx.compose.runtime.Composable
import org.example.project.enginepersonal.StempeluhrScreen

@Composable
fun MobileArbeitszeiterfassung() {
    StempeluhrScreen(mobileArbeitszeiterfassung = true)
}
